"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

//eslint-disable-next-line
var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {};
}; //eslint-disable-next-line


var Lockedstyles = {};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    Button: theme.Button
  };
});
/**
 * Simple Customizable Button with ripple effect
 */

var Button = /*#__PURE__*/_react["default"].forwardRef(function Button(props, ref) {
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));
  var Background = props.Background,
      Color = props.Color,
      Height = props.Height,
      Width = props.Width,
      FontSize = props.FontSize,
      ClassOverrideButton = props.ClassOverrideButton,
      ClassExtendButton = props.ClassExtendButton,
      style = props.style,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["Background", "Color", "Height", "Width", "FontSize", "ClassOverrideButton", "ClassExtendButton", "style", "children"]);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    ref: ref,
    style: (0, _extends2["default"])({}, style, {
      background: Background ? Background : null,
      color: Color ? Color : null,
      height: Height ? Height : null,
      width: Width ? Width : null,
      fontSize: FontSize ? FontSize : null
    }),
    className: ClassOverrideButton ? ClassOverrideButton : (0, _clsx["default"])(ClassExtendButton, classes.Button)
  }, other), children);
});

Button.defaultProps = {
  Background: null,
  Color: null,
  Height: null,
  Width: null,
  FontSize: null,
  ClassOverrideButton: null,
  ClassExtendButton: null
};
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  /**
   * Background Color
   */
  Background: _propTypes["default"].string,

  /**
   * Text Color
   */
  Color: _propTypes["default"].string,

  /**
   * Height
   */
  Height: _propTypes["default"].string,

  /**
   * Width
   */
  Width: _propTypes["default"].string,

  /**
   * fontSize
   */
  FontSize: _propTypes["default"].string,

  /**
   * Overrides  the class
   */
  ClassOverrideButton: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendButton: _propTypes["default"].string
} : void 0;
var _default = Button;
exports["default"] = _default;